import { create } from '@bufbuild/protobuf';

import {
  AddStickerPackToProfileRequest,
  AddStickerPackToProfileRequestSchema,
  GetStickerPackByIdRequest,
  GetStickerPackByIdRequestSchema,
  GetStickerPacksRequest,
  GetStickerPacksRequestSchema,
  GetUserInstalledStickerPacksRequest,
  GetUserInstalledStickerPacksRequestSchema,
  RemoveStickerPackFromProfileRequest,
  RemoveStickerPackFromProfileRequestSchema,
} from 'APP/wsApi/wsAppApi/types/sticker/sticker_requests_pb';
import {
  AddStickerPackToProfileResponse,
  GetStickerPackByIdResponse,
  GetStickerPacksResponse,
  GetUserInstalledStickerPacksResponse,
  RemoveStickerPackFromProfileResponse,
} from 'APP/wsApi/wsAppApi/types/sticker/sticker_responses_pb';

import { wsAppRequestManager } from '../WsAppApi';
import { WsRequest } from './request.types';

export function getStickerPacksRequest(
  data: WsRequest<GetStickerPacksRequest>
): Promise<GetStickerPacksResponse> {
  return wsAppRequestManager.request<GetStickerPacksResponse>({
    case: 'getStickerPacks',
    value: create(GetStickerPacksRequestSchema, data),
  });
}

export function getUserInstalledStickerPacksRequest(
  data: WsRequest<GetUserInstalledStickerPacksRequest>
): Promise<GetUserInstalledStickerPacksResponse> {
  return wsAppRequestManager.request<GetUserInstalledStickerPacksResponse>({
    case: 'getUserInstalledStickerPacks',
    value: create(GetUserInstalledStickerPacksRequestSchema, data),
  });
}

export function addStickerPackToProfileRequest(
  data: WsRequest<AddStickerPackToProfileRequest>
): Promise<AddStickerPackToProfileResponse> {
  return wsAppRequestManager.request<AddStickerPackToProfileResponse>({
    case: 'addStickerPackToProfile',
    value: create(AddStickerPackToProfileRequestSchema, data),
  });
}

export function getStickerPackByIdRequest(
  data: WsRequest<GetStickerPackByIdRequest>
): Promise<GetStickerPackByIdResponse> {
  return wsAppRequestManager.request<GetStickerPackByIdResponse>({
    case: 'getStickerPackById',
    value: create(GetStickerPackByIdRequestSchema, data),
  });
}

export function removeStickerPackFromProfileRequest(
  data: WsRequest<RemoveStickerPackFromProfileRequest>
): Promise<RemoveStickerPackFromProfileResponse> {
  return wsAppRequestManager.request<RemoveStickerPackFromProfileResponse>({
    case: 'removeStickerPackFromProfile',
    value: create(RemoveStickerPackFromProfileRequestSchema, data),
  });
}
